// src/config/apiConfig.js
export const API_BASE_URL = 'https://webadmin.capitalclothiers.net';
// export const API_BASE_URL = 'https://localhost:7288';